import {Grid} from '@yandex-delivery/blocks'
import {HeaderButton} from '@yandex-delivery/order-layout-blocks'
import clsx from 'clsx'
import {useState} from 'react'

import {desktopClasses} from './Menu.classes'

type Props = {
  text: string
  id: string
  items: {
    text: string
    href: string
  }[]
}

export function SingleColumnMenu({links}: {links: Props[]}) {
  const [activeMenuItem, setActiveMenuItem] = useState<string>(links[0].id)

  return (
    <Grid container direction="row">
      <Grid
        className={desktopClasses.titles}
        container
        direction="column"
        item
        xs
      >
        {links.map(({text, id}) => (
          <Grid alignItems="flex-start" container key={`menu-${id}`}>
            <Grid item>
              <Grid container direction="column">
                <Grid
                  item
                  onMouseEnter={() => {
                    setActiveMenuItem(id)
                  }}
                  xs
                >
                  <HeaderButton
                    active={activeMenuItem === id}
                    transparent
                    variant="pseudo"
                  >
                    {text}
                  </HeaderButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
      {links.map(({id, items}) => (
        <Grid
          className={clsx(desktopClasses.menus, {
            [desktopClasses.visible]: activeMenuItem === id,
          })}
          item
          key={`link-${id}`}
          xs
        >
          {activeMenuItem === id ? <SubMenu items={items} /> : null}
        </Grid>
      ))}
    </Grid>
  )
}

export function SubMenu({items}: {items: Props['items']}) {
  return (
    <>
      {items.map(({href, text}, index) => (
        <Grid item key={`menu-item-${index}`} xs>
          <HeaderButton href={href} size="s" transparent variant="pseudo">
            {text}
          </HeaderButton>
        </Grid>
      ))}
    </>
  )
}
